import React, { useCallback, useEffect } from 'react';
import AppLayout from '../../../../../component/appLayout';
import MembersNavbar from '../navBar';
import ActivityMain from '../../../../../component/activityMain';
import { getUserActivity } from '../../../../../services/projectServices';
import { useParams } from 'react-router';
import { isEmpty } from '../../../../../helpers/common';
import { rootStore } from '../../../../../mobx/rootStore';
import BottomSubNavigation from '../../../../../component/bottomNavigation/subNavigation';
import { getUserWorkspacePreferenceData } from '../../../../../helpers/firebaseHelper';
import { MY_TASKS_GROUP_FILTER_TYPE } from '../../../../../global/constants';

const Overview: React.FC = () => {
  //Mobx variable
  const { workspaceStore, taskStore } = rootStore;
  const { currentWorkspace } = workspaceStore;

  // Other variables
  const params: { id: string } = useParams();
  const user = currentWorkspace?.users?.find((user) => user?.id === params?.id);

  // load initial data
  const loadData = useCallback(async () => {
    if (!isEmpty(currentWorkspace?.id)) {
      // Read the activity and my task filter preference concurrently so the shared MembersNavbar
      // group-by is not gated on the activity fetch
      const [userFilter] = await Promise.all([
        getUserWorkspacePreferenceData('my_task_filter'),
        getUserActivity(params?.id)
      ]);
      taskStore.setMyTasksFilter(userFilter?.group_by ?? MY_TASKS_GROUP_FILTER_TYPE.DUE_DATE);
    }
  }, [params?.id, currentWorkspace?.id, taskStore]);

  useEffect(() => {
    loadData();
  }, [loadData]);
  return (
    <>
      <AppLayout>
        <MembersNavbar loadData={loadData} />
        <ActivityMain data={user} />
        <BottomSubNavigation />
      </AppLayout>
    </>
  );
};

export default Overview;
